export enum SelectedTypeEnumerator {
  FILE = 1,
  URL = 2,
}

export const selectedTypeEnumeratorMap: Map<SelectedTypeEnumerator, string> = new Map<SelectedTypeEnumerator, string>([
  [SelectedTypeEnumerator.FILE, 'subir arquivo'],
  [SelectedTypeEnumerator.URL, 'digitar URL'],
]);